import { useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import Designer from '@features/cms/components/collections/DesignersBlock/Designer';
import VoxboxWidget from '@features/cms/components/collections/VoxboxWidget/VoxboxWidget';
import styles from '@features/cms/components/collections/DesignersBlock/DesignersBlock.styles';
import { IDesignersBlock } from '@features/cms/typescript';
import DesignerTeam from '@features/cms/components/collections/DesignersBlock/DesignerTeam';
const DynamicVideoModal = dynamic(() => import('@components/VideoModal/VideoModal'), {
  ssr: false
});
type PropsType = {
  data: IDesignersBlock;
  isFirst?: boolean;
};
const DesignersBlock = ({
  data,
  isFirst = false
}: PropsType) => {
  const [isOpenModal, setIsModalOpen] = useState(false);
  const {
    title,
    image,
    description,
    buttonText,
    variant,
    designers,
    video,
    name,
    voxboxButton,
    code,
    email,
    phone
  } = data;
  const isVideoNullable = !video || video.desktop === null && video.mobile === null && video.tablet === null;
  const hoverRef = useRef<HTMLElement>(null);
  return <section id={code} sx={styles.designersSection} ref={hoverRef} data-cy={code} data-testid="designers-block">
      {variant === 'single' ? <Designer title={title} image={image} description={description} buttonText={buttonText} setIsModalOpen={setIsModalOpen} name={name} email={email} phone={phone} isFirst={isFirst} /> : <DesignerTeam title={title} description={description} designers={designers} name={name} isFirst={isFirst} />}

      {voxboxButton && <VoxboxWidget hoverRef={hoverRef} variant="dark" />}
      {!isVideoNullable && <DynamicVideoModal active={isOpenModal} closeModalFunc={setIsModalOpen} video={video} />}
    </section>;
};
export default DesignersBlock;